import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import type { ComplianceRequirement } from 'types/compliance';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import { formatCompliance, type ComplianceData } from './format-compliance';

export type { ComplianceData };

/**
 * Hook for compliance overlay display.
 * 
 * Per PATTERN.md: Hook wires domain + formatter, returns formatted data.
 */
export function useCompliance(requirement?: ComplianceRequirement): ComplianceData {
  const { t } = useTranslation(Namespaces.COMMON);

  return useMemo(() => {
    return formatCompliance({
      requirement,
      signInMessage: t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_OVERLAY_SIGN_IN_MESSAGE, {
        defaultValue: 'Real estate boards require that you sign in to see listing details',
      }),
      signInCta: t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_SIGN_IN_BUTTON, {
        defaultValue: 'Sign In',
      }),
      termsMessage: t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_OVERLAY_TERMS_OF_USE_MESSAGE, {
        defaultValue: 'Accept Terms of Use to see listing details',
      }),
      termsCta: t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_TERMS_BUTTON, {
        defaultValue: 'View',
      }),
    });
  }, [requirement, t]);
}
